import { MembershipsPage } from '@/imports/ui/pages/user/MembershipsPage';
import { restrictedRoute } from '@/utilities/restrictedRoute';

export default restrictedRoute(
  MembershipsPage,
  {
    requiresEvery: [],
  }
);
